export default {
    'Concerts': {
        en: 'Concerts',
        es: 'Conciertos',
        pt: 'Concertos'
    },
    'About': {
        en: 'About',
        es: 'Sobre',
        pt: 'Sobre'
    },
    'Impact': {
        en: 'Impact',
        es: 'Impacto',
        pt: 'Impacto'
    },
    'Gallery': {
        en: 'Gallery',
        es: 'Galería',
        pt: 'Galeria'
    },
    'Donate': {
        en: 'Donate',
        es: 'Donar',
        pt: 'Doar'
    },
    'Seasons': {
        en: 'Seasons',
        es: 'Temporadas',
        pt: 'Temporadas'
    },
    'Contribute': {
        en: 'Contribute',
        es: 'Contribuye',
        pt: 'Contribui'
    },
    'Contact Us': {
        en: 'Contact Us',
        es: 'Contáctanos',
        pt: 'Contate-Nos'
    },
    'Dashboard': {
        en: 'Dashboard',
        es: 'Dashboard',
        pt: 'Dashboard'
    },
    'Logout': {
        en: 'Logout',
        es: 'Salir',
        pt: 'Sair'
    },
    'Here': {
        en: 'Here',
        es: 'Aquí',
        pt: 'Aqui'
    },
    'HERE': {
        en: 'HERE',
        es: 'AQUÍ',
        pt: 'AQUI'
    },
    'Personal': {
        en: 'Personal',
        es: 'Personal',
        pt: 'Pessoal'
    },
    'Institution': {
        en: 'Institution',
        es: 'Institución',
        pt: 'Instituição'
    },
}
